export enum IDENTITY_PROOF_ORIGIN {
    EUROPEAN = 1,
    FOREIGN = 2,
}

export enum KYC_TYPE {
    IDENTITY_PROOF = 'IDENTITY_PROOF',
    REGISTRATION_PROOF = 'REGISTRATION_PROOF',
    ARTICLES_OF_ASSOCIATION = 'ARTICLES_OF_ASSOCIATION',
    SHAREHOLDER_DECLARATION = 'SHAREHOLDER_DECLARATION',
}

export interface IdentityProof {
    id: string;
    type: string;
    status: string;
    refused_type?: any;
    refused_message?: any;
    origin?: IDENTITY_PROOF_ORIGIN;
}

export interface KycDocument {
    id: string;
    type: string;
    status: string;
    refused_type?: any;
    refused_message?: any;
}

export interface IKycsResponse {
    _type?: string;
    identity_proof?: IdentityProof;
    articles_of_association?: KycDocument;
    registration_proof?: KycDocument;
    shareholder_declaration?: KycDocument;
}
